/**
 * Заплатки, нужные только веб-сборке. На устройстве файл ничего не делает.
 *
 * `collapsable={false}` — подсказка Android не «сплющивать» вью в нативной
 * иерархии. Её подмешивают детям нативные библиотеки (react-native-gesture-handler
 * при клонировании ребёнка жеста, react-native-keyboard-controller,
 * react-native-screens) — безусловно, без проверки платформы. В браузере проп
 * доходит до DOM-узла, React его не применяет, но на каждый рендер пишет в
 * консоль ошибку в четыре абзаца.
 *
 * Само предупреждение верное, но адресовано не нам: убрать проп можно только в
 * чужом коде, а на поведение в браузере он не влияет. Поэтому глушим ровно это
 * сообщение — остальные ошибки консоли проходят как были. На стенде это важнее
 * всего: раньше настоящие ошибки приходилось искать между копиями этой.
 */
import { Platform } from 'react-native';

if (Platform.OS === 'web' && typeof console !== 'undefined') {
  const error = console.error.bind(console);
  console.error = (...args) => {
    const first = args[0];
    if (typeof first === 'string' && first.includes('non-boolean attribute')) {
      const mentionsProp = args.some(
        arg => typeof arg === 'string' && arg === 'collapsable',
      );
      if (mentionsProp) {
        return;
      }
    }
    error(...args);
  };
}
